import "regenerator-runtime/runtime";
import 'ol/ol.css';
//import Circle from 'ol/geom/Circle';
//import Feature from 'ol/Feature';
import {fromLonLat} from 'ol/proj';
import GeoJSON from 'ol/format/GeoJSON';
import Map from 'ol/Map';
import View from 'ol/View';
import XYZ from 'ol/source/XYZ.js';
import {Circle as CircleStyle, Fill, Stroke, Style} from 'ol/style';
import {OSM, Vector as VectorSource} from 'ol/source';
import {Group as LayerGroup,Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import {Attribution,Control, defaults as defaultControls} from 'ol/control';
import { getUid } from 'ol/util';
import Select from 'ol/interaction/Select';
import Overlay from 'ol/Overlay';
import {altKeyOnly, click, pointerMove} from 'ol/events/condition';
import WebGLPointsLayer from 'ol/layer/WebGLPoints';
const myModule = require('./dataseries');
let dataSeries = myModule.getData();

var today = '13.10.2022';
var textlines ='' ;

var objSoilDepth= JSON.parse(JSON.stringify(require('./plot_932_wgs84_geo_soildepth.json')));


function readDatumTextFile(file, callback)
{
	var rawFile = new XMLHttpRequest();
    rawFile.open("GET", file, true);
    rawFile.onreadystatechange = function ()
    {
        if(rawFile.readyState === 4)
        {
            if(rawFile.status === 200 || rawFile.status == 0)
            {
                var allText = rawFile.responseText;
				textlines=allText.split("\r\n");
				
				today=textlines[1].substr(0,10);//textlines[1];
				if(callback) callback();
            }
        }
    }
	
    rawFile.send(null);
	
}
function readTextFile(file, callback) {
    var rawFile = new XMLHttpRequest();
    rawFile.overrideMimeType("application/json");
    rawFile.open("GET", file, true);
    rawFile.onreadystatechange = function() {
        if (rawFile.readyState === 4 && rawFile.status == "200") {
            callback(rawFile.responseText);
        }
    }
    rawFile.send(null);
}
function storeData(DOY, max, array) {
				array.push({ x:DOY,y:(Math.round(max* 100) / 100)});
}	

readDatumTextFile('https://life.hydro.tu-dresden.de/Nebelkarte/Trefferquote.txt', function(texx){
readTextFile('https://rekisviewer.hydro.tu-dresden.de/viewer/BoFeAm/Spruce_Forest/plot_932_wgs84_geo_rew_40.json', function(textt){

readTextFile('https://rekisviewer.hydro.tu-dresden.de/viewer/BoFeAm/Spruce_Forest/plot_932_wgs84_geo_rew_80.json', function(texttt){
	
readTextFile('https://rekisviewer.hydro.tu-dresden.de/viewer/BoFeAm/Spruce_Forest/plot_932_wgs84_geo_rew_100.json', function(textttt){
	
readTextFile('https://rekisviewer.hydro.tu-dresden.de/viewer/BoFeAm/Pine_Forest/plot_932_wgs84_geo_rew_100.json', function(text_pine_100){
readTextFile('https://rekisviewer.hydro.tu-dresden.de/viewer/BoFeAm/Pine_Forest/plot_932_wgs84_geo_rew_40.json', function(text_pine_40){
readTextFile('https://rekisviewer.hydro.tu-dresden.de/viewer/BoFeAm/Pine_Forest/plot_932_wgs84_geo_rew_80.json', function(text_pine_80){
	
readTextFile('https://rekisviewer.hydro.tu-dresden.de/viewer/BoFeAm/Oak_Forest/plot_932_wgs84_geo_rew_100.json', function(text_oak_100){
readTextFile('https://rekisviewer.hydro.tu-dresden.de/viewer/BoFeAm/Oak_Forest/plot_932_wgs84_geo_rew_40.json', function(text_oak_40){
readTextFile('https://rekisviewer.hydro.tu-dresden.de/viewer/BoFeAm/Oak_Forest/plot_932_wgs84_geo_rew_80.json', function(text_oak_80){	

readTextFile('https://rekisviewer.hydro.tu-dresden.de/viewer/BoFeAm/Beech_Forest/plot_932_wgs84_geo_rew_100.json', function(text_beech_100){
readTextFile('https://rekisviewer.hydro.tu-dresden.de/viewer/BoFeAm/Beech_Forest/plot_932_wgs84_geo_rew_40.json', function(text_beech_40){
readTextFile('https://rekisviewer.hydro.tu-dresden.de/viewer/BoFeAm/Beech_Forest/plot_932_wgs84_geo_rew_80.json', function(text_beech_80){	

readTextFile('https://rekisviewer.hydro.tu-dresden.de/viewer/BoFeAm/Grass_Land/plot_932_wgs84_geo_rew_100.json', function(text_grass_100){
readTextFile('https://rekisviewer.hydro.tu-dresden.de/viewer/BoFeAm/Grass_Land/plot_932_wgs84_geo_rew_40.json', function(text_grass_40){
readTextFile('https://rekisviewer.hydro.tu-dresden.de/viewer/BoFeAm/Grass_Land/plot_932_wgs84_geo_rew_80.json', function(text_grass_80){
	
readTextFile('https://rekisviewer.hydro.tu-dresden.de/viewer/BoFeAm/Wuchsbezirk/plot_Zielzustand_40.json', function(text_bwlf){	//BW_LF_WGS84_end.json', 'https://rekisviewer.hydro.tu-dresden.de/viewer/BoFeAm/Wuchsbezirk/plot_Zielzustand_40.json'  function(text_bwlf){	

var obj1 = JSON.parse(JSON.stringify(textttt));
var obj2 = JSON.parse(JSON.stringify(texttt));	
var obj3 = JSON.parse(JSON.stringify(textt));	

var obj_pine_100 = JSON.parse(JSON.stringify(text_pine_100));	
var obj_pine_80 = JSON.parse(JSON.stringify(text_pine_80));
var obj_pine_40 = JSON.parse(JSON.stringify(text_pine_40));

var obj_oak_100 = JSON.parse(JSON.stringify(text_oak_100));	
var obj_oak_80 = JSON.parse(JSON.stringify(text_oak_80));
var obj_oak_40 = JSON.parse(JSON.stringify(text_oak_40));

var obj_beech_100 = JSON.parse(JSON.stringify(text_beech_100));	
var obj_beech_80 = JSON.parse(JSON.stringify(text_beech_80));
var obj_beech_40 = JSON.parse(JSON.stringify(text_beech_40));

var obj_grass_100 = JSON.parse(JSON.stringify(text_grass_100));	
var obj_grass_80 = JSON.parse(JSON.stringify(text_grass_80));
var obj_grass_40 = JSON.parse(JSON.stringify(text_grass_40));

var obj_bwlf = JSON.parse(JSON.stringify(text_bwlf));

var dodownloadstuff=false;
var dorewstuff=true;


//import {defaults as defaultControls, Attribution} from 'ol/control.js';
var attribution = new Attribution({
  collapsible: false,
});


var LayerSwitcher = require('ol-layerswitcher'); //ol-layerswitcher.js //node_modules->dist-> uuid() ändern für custom input ids
//var charth = [];

var highlightStyle = [new Style({
	  fill: new Fill({
	    color: 'rgba(255,255,255,0.7)',
	  }),
	  stroke: new Stroke({
	    color: '#3399CC',
	    width: 3,
	  }),
	}),
	new Style({
    image: new CircleStyle({
      radius: 6,
      fill: new Fill({
        color: '#3399CC'
      }),
      stroke: new Stroke({color: 'white', width: 1})
    }),
   // geometry: function(feature) {
      // return the coordinates of the first ring of the polygon
	//	 var coordinates = feature.getGeometry().getCoordinates()[0];
     // return new Point(coordinates);
   // }
	})]
	
	var clickedStyle = [new Style({
	  fill: new Fill({
	    color: 'rgba(255,255,255,0.7)',
	  }),
	  stroke: new Stroke({
	    color: '#008ffb',
	    width: 3,
	  }),
	}),
	new Style({
    image: new CircleStyle({
      radius: 6,
      fill: new Fill({
        color: '#3399CC'
      }),
      stroke: new Stroke({color: 'white', width: 1})
    }),
   // geometry: function(feature) {
      // return the coordinates of the first ring of the polygon
	//	 var coordinates = feature.getGeometry().getCoordinates()[0];
     // return new Point(coordinates);
   // }
	})]


var image = new CircleStyle({
    radius: 4,
    fill: new Fill({
        color: 'rgba(255,0,0,0.6)'
      }),
    stroke: new Stroke({color: 'red', width: 1})
  });

var jsonDownloadStat= require('./download_geo.json');
var objDownloadStat = JSON.parse(JSON.stringify(jsonDownloadStat));
var vectorSourceD = new VectorSource({
	features: (new GeoJSON()).readFeatures(objDownloadStat,{
                        dataProjection: 'EPSG:4326',
                        featureProjection: 'EPSG:3857'
                    }),
					
	});	
	var styles = {
        'Point': new Style({
          image: image
        }),
		
      };
	  
	//  console.log(vectorSourceS);
	var vectorLayerDownload = new VectorLayer({
		title: 'Waldklimastationen',
		uuid:'DownloadStat',
		source: vectorSourceD,
		style: function(feature) {
			return styles[feature.getGeometry().getType()]},
		visible: true
	});
	
	


//var jsonPlots932= require('./plot_932_wgs84_geo_rew_40.json');
var objPlots932 = obj1;//JSON.parse(JSON.stringify(jsonPlots932));//obj1;
var vectorSourceS = new VectorSource({
	features: (new GeoJSON()).readFeatures(objPlots932,{
                        dataProjection: 'EPSG:4326',
                        featureProjection: 'EPSG:3857'
                    }),
					
	});	
	
var objPlots932_80 = obj2;//JSON.parse(JSON.stringify(jsonPlots932));//obj1;
var vectorSourceS_80 = new VectorSource({
	features: (new GeoJSON()).readFeatures(objPlots932_80,{
                        dataProjection: 'EPSG:4326',
                        featureProjection: 'EPSG:3857'
                    }),
					
	});		
	
var objPlots932_100 = obj3;//JSON.parse(JSON.stringify(jsonPlots932));//obj1;
var vectorSourceS_100 = new VectorSource({
	features: (new GeoJSON()).readFeatures(objPlots932_100,{
                        dataProjection: 'EPSG:4326',
                        featureProjection: 'EPSG:3857'
                    }),
					
	});	
	
	
	var objPlots_pine_40 = obj_pine_40;//JSON.parse(JSON.stringify(jsonPlots932));//obj1;
var vectorSource_pine_40 = new VectorSource({
	features: (new GeoJSON()).readFeatures(objPlots_pine_40,{
                        dataProjection: 'EPSG:4326',
                        featureProjection: 'EPSG:3857'
                    }),
					
	});	
	
var objPlots_pine_80 = obj_pine_80;//JSON.parse(JSON.stringify(jsonPlots932));//obj1;
var vectorSource_pine_80 = new VectorSource({
	features: (new GeoJSON()).readFeatures(objPlots_pine_80,{
                        dataProjection: 'EPSG:4326',
                        featureProjection: 'EPSG:3857'
                    }),
					
	});		
	
var objPlots_pine_100 = obj_pine_100;//JSON.parse(JSON.stringify(jsonPlots932));//obj1;
var vectorSource_pine_100 = new VectorSource({
	features: (new GeoJSON()).readFeatures(objPlots_pine_100,{
                        dataProjection: 'EPSG:4326',
                        featureProjection: 'EPSG:3857'
                    }),
					
	});	
	
		var objPlots_oak_40 = obj_oak_40;//JSON.parse(JSON.stringify(jsonPlots932));//obj1;
var vectorSource_oak_40 = new VectorSource({
	features: (new GeoJSON()).readFeatures(objPlots_oak_40,{
                        dataProjection: 'EPSG:4326',
                        featureProjection: 'EPSG:3857'
                    }),
					
	});	
	
var objPlots_oak_80 = obj_oak_80;//JSON.parse(JSON.stringify(jsonPlots932));//obj1;
var vectorSource_oak_80 = new VectorSource({
	features: (new GeoJSON()).readFeatures(objPlots_oak_80,{
                        dataProjection: 'EPSG:4326',
                        featureProjection: 'EPSG:3857'
                    }),
					
	});		
	
var objPlots_oak_100 = obj_oak_100;//JSON.parse(JSON.stringify(jsonPlots932));//obj1;
var vectorSource_oak_100 = new VectorSource({
	features: (new GeoJSON()).readFeatures(objPlots_oak_100,{
                        dataProjection: 'EPSG:4326',
                        featureProjection: 'EPSG:3857'
                    }),
					
	});	
		var objPlots_beech_40 = obj_beech_40;//JSON.parse(JSON.stringify(jsonPlots932));//obj1;
var vectorSource_beech_40 = new VectorSource({
	features: (new GeoJSON()).readFeatures(objPlots_beech_40,{
                        dataProjection: 'EPSG:4326',
                        featureProjection: 'EPSG:3857'
                    }),
					
	});	
	
var objPlots_beech_80 = obj_beech_80;//JSON.parse(JSON.stringify(jsonPlots932));//obj1;
var vectorSource_beech_80 = new VectorSource({
	features: (new GeoJSON()).readFeatures(objPlots_beech_80,{
                        dataProjection: 'EPSG:4326',
                        featureProjection: 'EPSG:3857'
                    }),
					
	});		
	
var objPlots_beech_100 = obj_beech_100;//JSON.parse(JSON.stringify(jsonPlots932));//obj1;
var vectorSource_beech_100 = new VectorSource({
	features: (new GeoJSON()).readFeatures(objPlots_beech_100,{
                        dataProjection: 'EPSG:4326',
                        featureProjection: 'EPSG:3857'
                    }),
					
	});	
	
		var objPlots_grass_40 = obj_grass_40;//JSON.parse(JSON.stringify(jsonPlots932));//obj1;
var vectorSource_grass_40 = new VectorSource({
	features: (new GeoJSON()).readFeatures(objPlots_grass_40,{
                        dataProjection: 'EPSG:4326',
                        featureProjection: 'EPSG:3857'
                    }),
					
	});	
	
var objPlots_grass_80 = obj_grass_80;//JSON.parse(JSON.stringify(jsonPlots932));//obj1;
var vectorSource_grass_80 = new VectorSource({
	features: (new GeoJSON()).readFeatures(objPlots_grass_80,{
                        dataProjection: 'EPSG:4326',
                        featureProjection: 'EPSG:3857'
                    }),
					
	});		
	
var objPlots_grass_100 = obj_grass_100;//JSON.parse(JSON.stringify(jsonPlots932));//obj1;
var vectorSource_grass_100 = new VectorSource({
	features: (new GeoJSON()).readFeatures(objPlots_grass_100,{
                        dataProjection: 'EPSG:4326',
                        featureProjection: 'EPSG:3857'
                    }),
					
	});	

var objPlots_bwlf = obj_bwlf;//JSON.parse(JSON.stringify(jsonPlots932));//obj1;
var vectorSource_bwlf = new VectorSource({
	features: (new GeoJSON()).readFeatures(objPlots_bwlf,{
                        dataProjection: 'EPSG:4326',
                        featureProjection: 'EPSG:3857'
                    }),
					
	});	
	
var styles = {
        'Point': new Style({
			image: new CircleStyle({
			radius: 6,
			fill: new Fill({color:'#82d732'}),
			stroke: new Stroke({color: 'white', width: 1})
			})
        }),
        'LineString': new Style({
          stroke: new Stroke({
            color: 'green',
            width: 1
          })
        }),
        'MultiLineString': new Style({
          stroke: new Stroke({
            color: 'green',
            width: 1
          })
        }),
        'MultiPoint': new Style({
          image: image
        }),
        'MultiPolygon': new Style({
          stroke: new Stroke({
            color: '#9f4f55',
			lineDash: [10],
            width: 2
          }),
          fill: new Fill({
            color: 'rgba(255, 255, 255, 0.1)'
          })
        }),
        'Polygon': new Style({
          stroke: new Stroke({
            color: '#91a373',
            lineDash: [10],
            width: 4
          }),
          fill: new Fill({
            color: 'rgba(255, 255, 255, 0.1)'
          })
        }),
        'GeometryCollection': new Style({
          stroke: new Stroke({
            color: 'magenta',
            width: 2
          }),
          fill: new Fill({
            color: 'magenta'
          }),
          image: new CircleStyle({
            radius: 10,
            fill: null,
            stroke: new Stroke({
              color: 'magenta'
            })
          })
        })
		
};
  
	/*var vectorLayerPlots = new VectorLayer({
		title: 'Standorte 932',
		uuid:'plots932',
		source: vectorSourceS,
		style: function(feature) {
			//console.log('Check you get the property : ', feature.get('rew'));
			var filli = new Fill();
			filli= new Fill({color:'#82d732'});
			if(feature.get('rew')!=null){
				if(feature.get('rew')<=0.4)		
					filli= new Fill({color:'#fac83c'});
				if(feature.get('rew')<=0.2)	
					filli= new Fill({color:'#c8642d'});
				if(feature.get('rew')>1.0)	
					filli= new Fill({color:'#0082fa'});
			}
			return [new Style({
					image: new CircleStyle({
						radius: 6,
						fill: filli,
						stroke: new Stroke({color: 'white', width: 1})
						})
					})]
			
			},
		visible: true
	});
	*/
const glStyle=  {
			variables: {
				selectedFeatureId: '',
				clickedFeatureId: ''
			},
			symbol: {
				symbolType: 'circle',
				size: 18,
				color: ['case',['==', ['get', 'id'], ['var', 'selectedFeatureId']], 'rgb(200, 200, 255)',
							['==', ['get', 'id'], ['var', 'clickedFeatureId']],'rgb(20, 0, 255)',
							['color', ['get', 'red'], ['get', 'green'], ['get', 'blue']]
						],
				offset:[0,9]		
			}
		};
		
		
const glStyleWB=  {
			variables: {
				selectedFeatureId: '',
				clickedFeatureId: ''
			},
			symbol: {
				symbolType: 'circle',
				size: ["interpolate",
						[
							"exponential",
							2.5
						],
						[
							"zoom"
						],
						6,
						1,
						12,
						32
				],
				color: ['case',['==', ['get', 'id'], ['var', 'selectedFeatureId']], 'rgb(200, 200, 255)',
							['==', ['get', 'id'], ['var', 'clickedFeatureId']],'rgb(20, 0, 255)',
							['color', ['get', 'red'], ['get', 'green'], ['get', 'blue']]
						],
				offset:[0,9]		
			}
		};		
	var vectorLayerPlots = new WebGLPointsLayer({
    title: 'BWI Standorte - REW für Fichte 40cm Bodentiefe',
		uuid:'plots932',
		source: vectorSourceS,
		style:glStyle,
		
    disableHitDetection: false,
	visible: true
  });
  
  	var vectorLayerPlots_80 = new WebGLPointsLayer({
    title: 'BWI Standorte - REW für Fichte 80cm Bodentiefe',
		uuid:'plots932_80',
		source: vectorSourceS_80,
		style:glStyle,
    disableHitDetection: false,
	visible: false
  });
	
	  	var vectorLayerPlots_100 = new WebGLPointsLayer({
    title: 'BWI Standorte - REW für Fichte 100cm Bodentiefe',
		uuid:'plots932_100',
		source: vectorSourceS_100,
		style:glStyle,
    disableHitDetection: false,
	visible: false
  });
  
  	var vectorLayerPlots_pine_40 = new WebGLPointsLayer({
    title: 'BWI Standorte - REW für Kiefer 40cm Bodentiefe',
		uuid:'plots_pine_40',
		source: vectorSource_pine_40,
		style:glStyle,
    disableHitDetection: false,
	visible: true
  });
  
  	var vectorLayerPlots_pine_80 = new WebGLPointsLayer({
    title: 'BWI Standorte - REW für Kiefer 80cm Bodentiefe',
		uuid:'plots_pine_80',
		source: vectorSource_pine_80,
		style:glStyle,
    disableHitDetection: false,
	visible: false
  });
	
	  	var vectorLayerPlots_pine_100 = new WebGLPointsLayer({
    title: 'BWI Standorte - REW für Kiefer 100cm Bodentiefe',
		uuid:'plots_pine_100',
		source: vectorSource_pine_100,
		style:glStyle,
    disableHitDetection: false,
	visible: false
  });
  
    	var vectorLayerPlots_oak_40 = new WebGLPointsLayer({
    title: 'BWI Standorte - REW für Eiche 40cm Bodentiefe',
		uuid:'plots_oak_40',
		source: vectorSource_oak_40,
		style:glStyle,
    disableHitDetection: false,
	visible: true
  });
  
  	var vectorLayerPlots_oak_80 = new WebGLPointsLayer({
    title: 'BWI Standorte - REW für Eiche 80cm Bodentiefe',
		uuid:'plots_oak_80',
		source: vectorSource_oak_80,
		style:glStyle,
    disableHitDetection: false,
	visible: false
  });
	
	  	var vectorLayerPlots_oak_100 = new WebGLPointsLayer({
    title: 'BWI Standorte - REW für Eiche 100cm Bodentiefe',
		uuid:'plots_oak_100',
		source: vectorSource_oak_100,
		style:glStyle,
    disableHitDetection: false,
	visible: false
  });
  
      	var vectorLayerPlots_beech_40 = new WebGLPointsLayer({
    title: 'BWI Standorte - REW für Buche 40cm Bodentiefe',
		uuid:'plots_beech_40',
		source: vectorSource_beech_40,
		style:glStyle,
    disableHitDetection: false,
	visible: true
  });
  
  	var vectorLayerPlots_beech_80 = new WebGLPointsLayer({
    title: 'BWI Standorte - REW für Buche 80cm Bodentiefe',
		uuid:'plots_beech_80',
		source: vectorSource_beech_80,
		style:glStyle,
    disableHitDetection: false,
	visible: false
  });
	
	  	var vectorLayerPlots_beech_100 = new WebGLPointsLayer({
    title: 'BWI Standorte - REW für Buche 100cm Bodentiefe',
		uuid:'plots_beech_100',
		source: vectorSource_beech_100,
		style:glStyle,
    disableHitDetection: false,
	visible: false
  });
  
        	var vectorLayerPlots_grass_40 = new WebGLPointsLayer({
    title: 'BWI Standorte - REW für Gras 40cm Bodentiefe',
		uuid:'plots_grass_40',
		source: vectorSource_grass_40,
		style:glStyle,
    disableHitDetection: false,
	visible: true
  });
  
  	var vectorLayerPlots_grass_80 = new WebGLPointsLayer({
    title: 'BWI Standorte - REW für Gras 80cm Bodentiefe',
		uuid:'plots_grass_80',
		source: vectorSource_grass_80,
		style:glStyle,
    disableHitDetection: false,
	visible: false
  });
	
	  	var vectorLayerPlots_grass_100 = new WebGLPointsLayer({
    title: 'BWI Standorte - REW für Gras 100cm Bodentiefe',
		uuid:'plots_grass_100',
		source: vectorSource_grass_100,
		style:glStyle,
    disableHitDetection: false,
	visible: false
  });
  
  	  	var vectorLayerPlots_bwlf = new WebGLPointsLayer({
    title: 'Standorte der Lokalbodenformen',
		uuid:'plots_bwlf',
		source: vectorSource_bwlf,
		style:glStyleWB,
    disableHitDetection: false,
	visible: true
  });
  
var jsonWBZgrenzen= require('./Wuchs_wgs84_simple.json');
var objWBZ = JSON.parse(JSON.stringify(jsonWBZgrenzen));
var vectorSourceWBZ = new VectorSource({
	features: (new GeoJSON()).readFeatures(objWBZ,{
                        dataProjection: 'EPSG:4326',
                        featureProjection: 'EPSG:3857'
                    }),
					
});	
var vectorLayerWuchsbezirke = new VectorLayer({
	title: 'Waldwuchsbezirke in Sachsen',
	uuid:'wuchsbezirke',
	source: vectorSourceWBZ,
	style: new Style({
          stroke: new Stroke({
            color: '#ffffff',
			/*lineDash: [10],*/
            width: 1
          }),
          fill: new Fill({
            color: 'rgba(255, 255, 255, 0.05)'
          })
        }),
	visible:true
});

var jsonLaendergrenzen= require('././SN_BLG_geowgs84.json');
var objLaender = JSON.parse(JSON.stringify(jsonLaendergrenzen));
var vectorSourceL = new VectorSource({
	features: (new GeoJSON()).readFeatures(objLaender,{
                        dataProjection: 'EPSG:4326',
						featureProjection: 'EPSG:3857'}
                    ),					
});	
var vectorLayerL = new VectorLayer({
	title: 'Grenzen des Freistaates Sachsen',
	uuid:'saxony',
	source: vectorSourceL,
	style: function(feature) {
			return styles[feature.getGeometry().getType()]},
	visible: false
});	

vectorLayerDownload.on('change:visible', function(){
	if(vectorLayerDownload.getVisible()){
		document.getElementById("SoilMoisturePanel").style.visibility = "hidden"; 
		document.getElementById("DownloadPanel").style.visibility = "visible"; 
		document.getElementById("SoilMoistureDummyPanel").style.visibility = "hidden"; 
		document.getElementById("SoilMoistureImpressumPanel").style.visibility = "hidden"; 
		document.getElementById('SoilMoistureAboutPanel').style.visibility = 'hidden';
		document.getElementById('statuss').style.visibility = 'hidden';
		document.getElementById('statuss').style.visibility = 'hidden';
		dodownloadstuff=true;
		dorewstuff=false;
		
	}else{
		document.getElementById("SoilMoisturePanel").style.visibility = "visible"; 
		document.getElementById("DownloadPanel").style.visibility = "hidden"; 
		document.getElementById("SoilMoistureDummyPanel").style.visibility = "hidden"; 
		document.getElementById("SoilMoistureImpressumPanel").style.visibility = "hidden"; 
		document.getElementById('SoilMoistureAboutPanel').style.visibility = 'hidden';
		document.getElementById('statuss').style.visibility = 'hidden';
		document.getElementById('statuss').style.visibility = 'hidden';
		dodownloadstuff=false;
		dorewstuff=true;
	}
	document.getElementById("statuss").innerHTML = '';
	document.getElementById("station").innerHTML = '';
	document.getElementById("levelII").innerHTML = '';
	document.getElementById("SAbk").innerHTML = '';
	ApexCharts.exec('quantiles','updateSeries',[{data:[]}],true);
	ApexCharts.exec('depth_rew','updateSeries',[{data:[]}],true);
	ApexCharts.exec('downloaddata','updateSeries',[{data:[]}],true);
	ApexCharts.exec('downloaddata2','updateSeries',[{data:[]}],true);
});	

//
// Define rotate to north control.
//
class WaldControl extends Control {
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(opt_options) {
    const options = opt_options || {};

    const button = document.createElement('button');
    button.innerHTML = 'Lokalbodenformen';
	button.setAttribute("class", "btnw");

    const element = document.createElement('div');
    element.className = 'Wald ol-unselectable ol-control';
    element.appendChild(button);

    super({
      element: element,
      target: options.target,
    });

    button.addEventListener('click', this.handleWald.bind(this), false);
  }

  handleWald() {
 overlay.setPosition(undefined);
  closer.blur();
        this.getMap().getLayers().forEach(function (layerr) {
		map.removeLayer(layerr);
		});
    this.getMap().getLayers().forEach(function (layerr) {
		map.removeLayer(layerr);
		});
	const boxesk = document.querySelectorAll('.btnk');
	boxesk.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});
	const boxesf = document.querySelectorAll('.btnf');
	boxesf.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});
	const boxesb = document.querySelectorAll('.btnb');
	boxesb.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});
	const boxese = document.querySelectorAll('.btne');
	boxese.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});
	const boxeski = document.querySelectorAll('.btnki');
	boxeski.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});
	const boxesg = document.querySelectorAll('.btng');
	boxesg.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});	
	const boxesw = document.querySelectorAll('.btnw');
	boxesw.forEach(box => {
		box.style.backgroundColor = '#5b9ad5';
	});	
	this.getMap().addLayer(new LayerGroup({
		title: 'Standorte',
		layers: [new LayerGroup({
		'title': 'Hintergrundkarte',
		layers:[
			new TileLayer({
				title: 'OSM',
				uuid:'osm',
				type: 'base',
				visible: false,
				source: new OSM({attributions: 'REW: <span class="dot" style="background-color:#0082fa;"></span>=sehr nass '+
			  '<span class="dot" style="background-color:#82d732;"></span>=normal '+
			  '<span class="dot" style="background-color:#fac83c;"></span>=trocken '+
			  '<span class="dot" style="background-color:#c8642d;"></span>=sehr trocken '+' - © OpenStreetMap'})
			}),
			new TileLayer({
				title: 'ESRI',
				uuid:'esri',
				type: 'base',
				visible: true,
                source: new XYZ({
              attributions: 'REW: <span class="dot" style="background-color:#0082fa;"></span>=sehr nass '+
			  '<span class="dot" style="background-color:#82d732;"></span>=normal '+
			  '<span class="dot" style="background-color:#fac83c;"></span>=trocken '+
			  '<span class="dot" style="background-color:#c8642d;"></span>=sehr trocken '+
			  ' - © <a href="https://services.arcgisonline.com/ArcGIS/' +
                  'rest/services/World_Imagery/MapServer">ArcGIS</a>',
              url: 'https://server.arcgisonline.com/ArcGIS/rest/services/' +
                  'World_Imagery/MapServer/tile/{z}/{y}/{x}'
            })
          })
		]	
	}),vectorLayerL ,vectorLayerWuchsbezirke,vectorLayerPlots_bwlf]
	}));
		document.getElementById("SoilMoisturePanel").style.visibility = "hidden"; 
		document.getElementById("DownloadPanel").style.visibility = "hidden"; 
		document.getElementById("SoilMoistureDummyPanel").style.visibility = "visible";
		document.getElementById("SoilMoistureImpressumPanel").style.visibility = "hidden"; 
		document.getElementById('SoilMoistureAboutPanel').style.visibility = 'hidden';
		document.getElementById('statuss').style.visibility = 'hidden';
		document.getElementById("statuss").innerHTML = '&nbsp;';
		document.getElementById('expBtn').disabled=false;
		dodownloadstuff=false;
		dorewstuff=true;
		//document.getElementById('Bodenprofilpic').style.visibility = 'hidden';
	    document.getElementById("myChartdiv").scrollTop = 0;
  
  }
}


class BucheControl extends Control {
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(opt_options) {
    const options = opt_options || {};

    const button = document.createElement('button');
    button.innerHTML = 'BWI: Buche';
	button.setAttribute("class", "btnb");

    const element = document.createElement('div');
    element.className = 'Buche ol-unselectable ol-control';
    element.appendChild(button);

    super({
      element: element,
      target: options.target,
    });

    button.addEventListener('click', this.handleBuche.bind(this), false);
  }

  handleBuche() {
 overlay.setPosition(undefined);
  closer.blur();
        this.getMap().getLayers().forEach(function (layerr) {
		map.removeLayer(layerr);
		});
    this.getMap().getLayers().forEach(function (layerr) {
		map.removeLayer(layerr);
		});
	const boxesk = document.querySelectorAll('.btnk');
	boxesk.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});
	const boxesf = document.querySelectorAll('.btnf');
	boxesf.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});
	const boxesb = document.querySelectorAll('.btnb');
	boxesb.forEach(box => {
		box.style.backgroundColor = '#5b9ad5';
	});
	const boxese = document.querySelectorAll('.btne');
	boxese.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});
	const boxeski = document.querySelectorAll('.btnki');
	boxeski.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});
	const boxesg = document.querySelectorAll('.btng');
	boxesg.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});	
	const boxesw = document.querySelectorAll('.btnw');
	boxesw.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});	
	this.getMap().addLayer(new LayerGroup({
		title: 'Buche',
		layers: [new LayerGroup({
		'title': 'Hintergrundkarte',
		layers:[
			new TileLayer({
				title: 'OSM',
				uuid:'osm',
				type: 'base',
				visible: false,
				source: new OSM({attributions: 'REW: <span class="dot" style="background-color:#0082fa;"></span>=sehr nass '+
			  '<span class="dot" style="background-color:#82d732;"></span>=normal '+
			  '<span class="dot" style="background-color:#fac83c;"></span>=trocken '+
			  '<span class="dot" style="background-color:#c8642d;"></span>=sehr trocken '+' - © OpenStreetMap'})
			}),
			new TileLayer({
				title: 'ESRI',
				uuid:'esri',
				type: 'base',
				visible: true,
                source: new XYZ({
              attributions: 'REW: <span class="dot" style="background-color:#0082fa;"></span>=sehr nass '+
			  '<span class="dot" style="background-color:#82d732;"></span>=normal '+
			  '<span class="dot" style="background-color:#fac83c;"></span>=trocken '+
			  '<span class="dot" style="background-color:#c8642d;"></span>=sehr trocken '+
			  ' - © <a href="https://services.arcgisonline.com/ArcGIS/' +
                  'rest/services/World_Imagery/MapServer">ArcGIS</a>',
              url: 'https://server.arcgisonline.com/ArcGIS/rest/services/' +
                  'World_Imagery/MapServer/tile/{z}/{y}/{x}'
            })
          })
		]	
	}),vectorLayerL,vectorLayerWuchsbezirke ,vectorLayerPlots_beech_100,vectorLayerPlots_beech_80,vectorLayerPlots_beech_40]
	}));
		document.getElementById("SoilMoisturePanel").style.visibility = "hidden"; 
		document.getElementById("DownloadPanel").style.visibility = "hidden"; 
		document.getElementById("SoilMoistureDummyPanel").style.visibility = "visible";
		document.getElementById("SoilMoistureImpressumPanel").style.visibility = "hidden"; 
		document.getElementById('SoilMoistureAboutPanel').style.visibility = 'hidden';
		document.getElementById('statuss').style.visibility = 'hidden';
		document.getElementById("statuss").innerHTML = '&nbsp;';
		document.getElementById('expBtn').disabled=false;
		dodownloadstuff=false;
		dorewstuff=true;
		//document.getElementById('Bodenprofilpic').style.visibility = 'hidden';
	    document.getElementById("myChartdiv").scrollTop = 0;
  
  }
}

class FichteControl extends Control {
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(opt_options) {
    const options = opt_options || {};

    const button = document.createElement('button');
    button.innerHTML = 'BWI: Fichte';
	button.setAttribute("class", "btnf");

    const element = document.createElement('div');
    element.className = 'Fichte ol-unselectable ol-control';
    element.appendChild(button);

    super({
      element: element,
      target: options.target,
    });

    button.addEventListener('click', this.handleFichte.bind(this), false);
  }

  handleFichte() {
	  overlay.setPosition(undefined);
  closer.blur();
    this.getMap().getLayers().forEach(function (layerr) {
		map.removeLayer(layerr);
		});
    this.getMap().getLayers().forEach(function (layerr) {
		map.removeLayer(layerr);
		});
	const boxesk = document.querySelectorAll('.btnk');
	boxesk.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});
	const boxesf = document.querySelectorAll('.btnf');
	boxesf.forEach(box => {
		box.style.backgroundColor = '#5b9ad5';
	});
	const boxesb = document.querySelectorAll('.btnb');
	boxesb.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});
	const boxese = document.querySelectorAll('.btne');
	boxese.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});
	const boxeski = document.querySelectorAll('.btnki');
	boxeski.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});
	const boxesg = document.querySelectorAll('.btng');
	boxesg.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});	
		//this.getMap().getLayers().getArray().filter(layer => layer.get('uuid').toString().includes('plots')).forEach(layer => map.removeLayer(layer));
	const boxesw = document.querySelectorAll('.btnw');
	boxesw.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});	
	this.getMap().addLayer(new LayerGroup({
		title: 'Fichte',
		layers: [new LayerGroup({
		'title': 'Hintergrundkarte',
		layers:[
			new TileLayer({
				title: 'OSM',
				uuid:'osm',
				type: 'base',
				visible: false,
				source: new OSM({attributions: 'REW: <span class="dot" style="background-color:#0082fa;"></span>=sehr nass '+
			  '<span class="dot" style="background-color:#82d732;"></span>=normal '+
			  '<span class="dot" style="background-color:#fac83c;"></span>=trocken '+
			  '<span class="dot" style="background-color:#c8642d;"></span>=sehr trocken '+' - © OpenStreetMap'})
			}),
			new TileLayer({
				title: 'ESRI',
				uuid:'esri',
				type: 'base',
				visible: true,
                source: new XYZ({
              attributions: 'REW: <span class="dot" style="background-color:#0082fa;"></span>=sehr nass '+
			  '<span class="dot" style="background-color:#82d732;"></span>=normal '+
			  '<span class="dot" style="background-color:#fac83c;"></span>=trocken '+
			  '<span class="dot" style="background-color:#c8642d;"></span>=sehr trocken '+
			  ' - © <a href="https://services.arcgisonline.com/ArcGIS/' +
                  'rest/services/World_Imagery/MapServer">ArcGIS</a>',
              url: 'https://server.arcgisonline.com/ArcGIS/rest/services/' +
                  'World_Imagery/MapServer/tile/{z}/{y}/{x}'
            })
          })
		]	
	}),vectorLayerL ,vectorLayerWuchsbezirke,vectorLayerPlots_100,vectorLayerPlots_80,vectorLayerPlots]
	}));
		document.getElementById("SoilMoisturePanel").style.visibility = "hidden"; 
		document.getElementById("DownloadPanel").style.visibility = "hidden"; 
		document.getElementById("SoilMoistureDummyPanel").style.visibility = "visible"; 
		document.getElementById("SoilMoistureImpressumPanel").style.visibility = "hidden"; 
		document.getElementById('SoilMoistureAboutPanel').style.visibility = 'hidden';
		document.getElementById('statuss').style.visibility = 'hidden';
		document.getElementById("statuss").innerHTML = '&nbsp;';
		document.getElementById('expBtn').disabled=false;
		dodownloadstuff=false;
		dorewstuff=true;
		//document.getElementById('Bodenprofilpic').style.visibility = 'hidden';
	    document.getElementById("myChartdiv").scrollTop = 0;

  }
}

class EicheControl extends Control {
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(opt_options) {
    const options = opt_options || {};

    const button = document.createElement('button');
    button.innerHTML = 'BWI: Eiche';
	button.setAttribute("class", "btne");

    const element = document.createElement('div');
    element.className = 'Eiche ol-unselectable ol-control';
    element.appendChild(button);

    super({
      element: element,
      target: options.target,
    });

    button.addEventListener('click', this.handleEiche.bind(this), false);
  }

  handleEiche() {
	  overlay.setPosition(undefined);
  closer.blur();
    this.getMap().getLayers().forEach(function (layerr) {
		map.removeLayer(layerr);
		});
    this.getMap().getLayers().forEach(function (layerr) {
		map.removeLayer(layerr);
		});
		
		//this.getMap().getLayers().getArray().filter(layer => layer.get('uuid').toString().includes('plots')).forEach(layer => map.removeLayer(layer));
	const boxesk = document.querySelectorAll('.btnk');
	boxesk.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});
	const boxesf = document.querySelectorAll('.btnf');
	boxesf.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});
	const boxesb = document.querySelectorAll('.btnb');
	boxesb.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});
	const boxese = document.querySelectorAll('.btne');
	boxese.forEach(box => {
		box.style.backgroundColor = '#5b9ad5';
	});
	const boxeski = document.querySelectorAll('.btnki');
	boxeski.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});
	const boxesg = document.querySelectorAll('.btng');
	boxesg.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});	
	const boxesw = document.querySelectorAll('.btnw');
	boxesw.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});	
	this.getMap().addLayer(new LayerGroup({
		title: 'Eiche',
		layers: [new LayerGroup({
		'title': 'Hintergrundkarte',
		layers:[
			new TileLayer({
				title: 'OSM',
				uuid:'osm',
				type: 'base',
				visible: false,
				source: new OSM({attributions: 'REW: <span class="dot" style="background-color:#0082fa;"></span>=sehr nass '+
			  '<span class="dot" style="background-color:#82d732;"></span>=normal '+
			  '<span class="dot" style="background-color:#fac83c;"></span>=trocken '+
			  '<span class="dot" style="background-color:#c8642d;"></span>=sehr trocken'+' - © OpenStreetMap'})
			}),
			new TileLayer({
				title: 'ESRI',
				uuid:'esri',
				type: 'base',
				visible: true,
                source: new XYZ({
              attributions: 'REW: <span class="dot" style="background-color:#0082fa;"></span>=sehr nass '+
			  '<span class="dot" style="background-color:#82d732;"></span>=normal '+
			  '<span class="dot" style="background-color:#fac83c;"></span>=trocken '+
			  '<span class="dot" style="background-color:#c8642d;"></span>=sehr trocken '+
			  ' - © <a href="https://services.arcgisonline.com/ArcGIS/' +
                  'rest/services/World_Imagery/MapServer">ArcGIS</a>',
              url: 'https://server.arcgisonline.com/ArcGIS/rest/services/' +
                  'World_Imagery/MapServer/tile/{z}/{y}/{x}'
            })
          })
		]	
	}),vectorLayerL,vectorLayerWuchsbezirke,vectorLayerPlots_oak_100,vectorLayerPlots_oak_80,vectorLayerPlots_oak_40]
	}));
		document.getElementById("SoilMoisturePanel").style.visibility = "hidden"; 
		document.getElementById("DownloadPanel").style.visibility = "hidden"; 
		document.getElementById("SoilMoistureDummyPanel").style.visibility = "visible";
		document.getElementById("SoilMoistureImpressumPanel").style.visibility = "hidden"; 
		document.getElementById('SoilMoistureAboutPanel').style.visibility = 'hidden';
		document.getElementById('statuss').style.visibility = 'hidden';
		document.getElementById("statuss").innerHTML = '&nbsp;';
		document.getElementById('expBtn').disabled=false;
		dodownloadstuff=false;
		dorewstuff=true;
		//document.getElementById('Bodenprofilpic').style.visibility = 'hidden';
	    document.getElementById("myChartdiv").scrollTop = 0;

  }
}

class KieferControl extends Control {
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(opt_options) {
    const options = opt_options || {};

    const button = document.createElement('button');
    button.innerHTML = 'BWI: Kiefer';
	button.setAttribute("class", "btnki");

    const element = document.createElement('div');
    element.className = 'Kiefer ol-unselectable ol-control';
    element.appendChild(button);

    super({
      element: element,
      target: options.target,
    });

    button.addEventListener('click', this.handleKiefer.bind(this), false);
  }

  handleKiefer() {
	  overlay.setPosition(undefined);
  closer.blur();
    this.getMap().getLayers().forEach(function (layerr) {
		map.removeLayer(layerr);
		});
    this.getMap().getLayers().forEach(function (layerr) {
		map.removeLayer(layerr);
		});
	const boxesk = document.querySelectorAll('.btnk');
	boxesk.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});
	const boxesf = document.querySelectorAll('.btnf');
	boxesf.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});
	const boxesb = document.querySelectorAll('.btnb');
	boxesb.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});
	const boxese = document.querySelectorAll('.btne');
	boxese.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});
	const boxeski = document.querySelectorAll('.btnki');
	boxeski.forEach(box => {
		box.style.backgroundColor = '#5b9ad5';
	});
	const boxesg = document.querySelectorAll('.btng');
	boxesg.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});	
		//this.getMap().getLayers().getArray().filter(layer => layer.get('uuid').toString().includes('plots')).forEach(layer => map.removeLayer(layer));
	const boxesw = document.querySelectorAll('.btnw');
	boxesw.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});		
	this.getMap().addLayer(new LayerGroup({
		title: 'Kiefer',
		layers: [new LayerGroup({
		'title': 'Hintergrundkarte',
		layers:[
			new TileLayer({
				title: 'OSM',
				uuid:'osm',
				type: 'base',
				visible: false,
				source: new OSM({attributions: 'REW: <span class="dot" style="background-color:#0082fa;"></span>=sehr nass '+
			  '<span class="dot" style="background-color:#82d732;"></span>=normal '+
			  '<span class="dot" style="background-color:#fac83c;"></span>=trocken '+
			  '<span class="dot" style="background-color:#c8642d;"></span>=sehr trocken '+' - © OpenStreetMap'})
			}),
			new TileLayer({
				title: 'ESRI',
				uuid:'esri',
				type: 'base',
				visible: true,
                source: new XYZ({
              attributions: 'REW: <span class="dot" style="background-color:#0082fa;"></span>=sehr nass '+
			  '<span class="dot" style="background-color:#82d732;"></span>=normal '+
			  '<span class="dot" style="background-color:#fac83c;"></span>=trocken '+
			  '<span class="dot" style="background-color:#c8642d;"></span>=sehr trocken '+
			  ' - © <a href="https://services.arcgisonline.com/ArcGIS/' +
                  'rest/services/World_Imagery/MapServer">ArcGIS</a>',
              url: 'https://server.arcgisonline.com/ArcGIS/rest/services/' +
                  'World_Imagery/MapServer/tile/{z}/{y}/{x}'
            })
          })
		]	
	}),vectorLayerL ,vectorLayerWuchsbezirke,vectorLayerPlots_pine_100,vectorLayerPlots_pine_80,vectorLayerPlots_pine_40]
	}));
		document.getElementById("SoilMoisturePanel").style.visibility = "hidden"; 
		document.getElementById("DownloadPanel").style.visibility = "hidden"; 
		document.getElementById("SoilMoistureDummyPanel").style.visibility = "visible";
		document.getElementById("SoilMoistureImpressumPanel").style.visibility = "hidden"; 
		document.getElementById('SoilMoistureAboutPanel').style.visibility = 'hidden';
		document.getElementById('statuss').style.visibility = 'hidden';
		document.getElementById("statuss").innerHTML = '&nbsp;';
		document.getElementById('expBtn').disabled=false;
		dodownloadstuff=false;
		dorewstuff=true;
		//document.getElementById('Bodenprofilpic').style.visibility = 'hidden';
	    document.getElementById("myChartdiv").scrollTop = 0;
  
  }
}

class GrasControl extends Control {
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(opt_options) {
    const options = opt_options || {};

    const button = document.createElement('button');
    button.innerHTML = 'BWI: Gras';
	button.setAttribute("class", "btng");

    const element = document.createElement('div');
    element.className = 'Gras ol-unselectable ol-control';
    element.appendChild(button);

    super({
      element: element,
      target: options.target,
    });

    button.addEventListener('click', this.handleGras.bind(this), false);
  }

  handleGras() {
	  overlay.setPosition(undefined);
  closer.blur();
    this.getMap().getLayers().forEach(function (layerr) {
		map.removeLayer(layerr);
		});
    this.getMap().getLayers().forEach(function (layerr) {
		map.removeLayer(layerr);
		});
	const boxesk = document.querySelectorAll('.btnk');
	boxesk.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});
	const boxesf = document.querySelectorAll('.btnf');
	boxesf.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});
	const boxesb = document.querySelectorAll('.btnb');
	boxesb.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});
	const boxese = document.querySelectorAll('.btne');
	boxese.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});
	const boxeski = document.querySelectorAll('.btnki');
	boxeski.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});
	const boxesg = document.querySelectorAll('.btng');
	boxesg.forEach(box => {
		box.style.backgroundColor = '#5b9ad5';
	});	
		//this.getMap().getLayers().getArray().filter(layer => layer.get('uuid').toString().includes('plots')).forEach(layer => map.removeLayer(layer));
		const boxesw = document.querySelectorAll('.btnw');
	boxesw.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});	
	this.getMap().addLayer(new LayerGroup({
		title: 'Gras',
		layers: [new LayerGroup({
		'title': 'Hintergrundkarte',
		layers:[
			new TileLayer({
				title: 'OSM',
				uuid:'osm',
				type: 'base',
				visible: false,
				source: new OSM({attributions: 'REW: <span class="dot" style="background-color:#0082fa;"></span>=sehr nass '+
			  '<span class="dot" style="background-color:#82d732;"></span>=normal '+
			  '<span class="dot" style="background-color:#fac83c;"></span>=trocken '+
			  '<span class="dot" style="background-color:#c8642d;"></span>=sehr trocken '+' - © OpenStreetMap'})
			}),
			new TileLayer({
				title: 'ESRI',
				uuid:'esri',
				type: 'base',
				visible: true,
                source: new XYZ({
              attributions: 'REW: <span class="dot" style="background-color:#0082fa;"></span>=sehr nass '+
			  '<span class="dot" style="background-color:#82d732;"></span>=normal '+
			  '<span class="dot" style="background-color:#fac83c;"></span>=trocken '+
			  '<span class="dot" style="background-color:#c8642d;"></span>=sehr trocken '+
			  ' - © <a href="https://services.arcgisonline.com/ArcGIS/' +
                  'rest/services/World_Imagery/MapServer">ArcGIS</a>',
              url: 'https://server.arcgisonline.com/ArcGIS/rest/services/' +
                  'World_Imagery/MapServer/tile/{z}/{y}/{x}'
            })
          })
		]	
	}),vectorLayerL,vectorLayerWuchsbezirke,vectorLayerPlots_grass_100,vectorLayerPlots_grass_80,vectorLayerPlots_grass_40]
	}));	
	
		document.getElementById("SoilMoisturePanel").style.visibility = "hidden"; 
		document.getElementById("DownloadPanel").style.visibility = "hidden"; 
		document.getElementById("SoilMoistureDummyPanel").style.visibility = "visible"; 
		document.getElementById("SoilMoistureImpressumPanel").style.visibility = "hidden"; 
		document.getElementById('SoilMoistureAboutPanel').style.visibility = 'hidden';
		document.getElementById('statuss').style.visibility = 'hidden';
		document.getElementById("statuss").innerHTML = '&nbsp;';
		document.getElementById('expBtn').disabled=false;
		dodownloadstuff=false;
		dorewstuff=true;
		//document.getElementById('Bodenprofilpic').style.visibility = 'hidden';
	    document.getElementById("myChartdiv").scrollTop = 0;
  }
}

class KlimaControl extends Control {
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(opt_options) {
    const options = opt_options || {};

    const button = document.createElement('button');
    button.innerHTML = 'Waldklimadaten';
	button.setAttribute("class", "btnk");

    const element = document.createElement('div');
    element.className = 'Klima ol-unselectable ol-control';
    element.appendChild(button);

    super({
      element: element,
      target: options.target,
    });

    button.addEventListener('click', this.handleKlima.bind(this), false);
  }

  handleKlima() {
	  overlay.setPosition(undefined);
  closer.blur();
    this.getMap().getLayers().forEach(function (layerr) {
		map.removeLayer(layerr);
		});
    this.getMap().getLayers().forEach(function (layerr) {
		map.removeLayer(layerr);
		});
	const boxesk = document.querySelectorAll('.btnk');
	boxesk.forEach(box => {
		box.style.backgroundColor = '#5b9ad5';
	});
	const boxesf = document.querySelectorAll('.btnf');
	boxesf.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});
	const boxesb = document.querySelectorAll('.btnb');
	boxesb.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});
	const boxese = document.querySelectorAll('.btne');
	boxese.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});
	const boxeski = document.querySelectorAll('.btnki');
	boxeski.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});
	const boxesg = document.querySelectorAll('.btng');
	boxesg.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});

		//this.getMap().getLayers().getArray().filter(layer => layer.get('uuid').toString().includes('plots')).forEach(layer => map.removeLayer(layer));
	const boxesw = document.querySelectorAll('.btnw');
	boxesw.forEach(box => {
		box.style.backgroundColor = 'rgba(0,60,136,0.5)';
	});		
	this.getMap().addLayer(new LayerGroup({
		title: 'Klima',
		layers: [new LayerGroup({
		'title': 'Hintergrundkarte',
		layers:[
			new TileLayer({
				title: 'OSM',
				uuid:'osm',
				type: 'base',
				visible: false,
				source: new OSM({attributions: 'REW: <span class="dot" style="background-color:#0082fa;"></span>=sehr nass '+
			  '<span class="dot" style="background-color:#82d732;"></span>=normal '+
			  '<span class="dot" style="background-color:#fac83c;"></span>=trocken '+
			  '<span class="dot" style="background-color:#c8642d;"></span>=sehr trocken '+' - © OpenStreetMap'})
			}),
			new TileLayer({
				title: 'ESRI',
				uuid:'esri',
				type: 'base',
				visible: true,
                source: new XYZ({
              attributions: 'REW: <span class="dot" style="background-color:#0082fa;"></span>=sehr nass '+
			  '<span class="dot" style="background-color:#82d732;"></span>=normal '+
			  '<span class="dot" style="background-color:#fac83c;"></span>=trocken '+
			  '<span class="dot" style="background-color:#c8642d;"></span>=sehr trocken '+
			  ' - © <a href="https://services.arcgisonline.com/ArcGIS/' +
                  'rest/services/World_Imagery/MapServer">ArcGIS</a>',
              url: 'https://server.arcgisonline.com/ArcGIS/rest/services/' +
                  'World_Imagery/MapServer/tile/{z}/{y}/{x}'
            })
          })
		]	
	}),vectorLayerL,vectorLayerWuchsbezirke ,vectorLayerDownload]
	}));

	    document.getElementById("SoilMoisturePanel").style.visibility = "hidden"; 
		document.getElementById("DownloadPanel").style.visibility = "visible"; 
		document.getElementById("SoilMoistureDummyPanel").style.visibility = "hidden"; 
		document.getElementById("SoilMoistureImpressumPanel").style.visibility = "hidden"; 
		document.getElementById('SoilMoistureAboutPanel').style.visibility = 'hidden';
		document.getElementById('statuss').style.visibility = 'visible';
		document.getElementById('statuss').style.visibility = 'visible';
		document.getElementById('statuss').innerHTML = '&nbsp;';
		document.getElementById('expBtn').disabled=true;
		//document.getElementById('Bodenprofilpic').style.visibility = 'hidden';
		dodownloadstuff=true;
		dorewstuff=false;
		//document.getElementById('Bodenprofilpic').style.visibility = 'hidden';
	    document.getElementById("myChartdiv").scrollTop = 0;
		
		ApexCharts.exec('downloaddata','updateOptions',{
					yaxis: {
						title: { text: ''},
		            },
					title: {
						text: '',
					},
				},false,true);
		ApexCharts.exec('downloaddata','updateSeries',[{data:[]}],true);
		ApexCharts.exec('downloaddata2','updateOptions',{
					yaxis: {
						title: { text: ''},
		            },
					title: {
						text: '',
					},
				},false,true);
		ApexCharts.exec('downloaddata2','updateSeries',[{data:[]}],true);
	//divElementt.scroll({
	//top: divElementt.scrollTop,//scroll to the bottom of the element
	//behavior: 'smooth' //auto, smooth, initial, inherit
//});
  }
}

/**
 * Elements that make up the popup.
 */
const container = document.getElementById('popup');
const content = document.getElementById('popup-content');
const closer = document.getElementById('popup-closer');

/**
 * Create an overlay to anchor the popup to the map.
 */
const overlay = new Overlay({
  element: container,
  autoPan: {
    animation: {
      duration: 250,
    },
  },
});

/**
 * Add a click handler to hide the popup.
 * @return {boolean} Don't follow the href.
 */
closer.onclick = function () {
  overlay.setPosition(undefined);
  closer.blur();
  return false;
};

var map = new Map({
  layers: [
	new LayerGroup({
		'title': 'Hintergrundkarte',
		layers:[
			new TileLayer({
				title: 'OSM',
				uuid:'osm',
				type: 'base',
				visible: false,
				source: new OSM({attributions: 'REW: <span class="dot" style="background-color:#0082fa;"></span>=sehr nass '+
			  '<span class="dot" style="background-color:#82d732;"></span>=normal '+
			  '<span class="dot" style="background-color:#fac83c;"></span>=trocken '+
			  '<span class="dot" style="background-color:#c8642d;"></span>=sehr trocken '+' - © OpenStreetMap'})
			}),
			new TileLayer({
				title: 'ESRI',
				uuid:'esri',
				type: 'base',
				visible: true,
                source: new XYZ({
              attributions: 'REW: <span class="dot" style="background-color:#0082fa;"></span>=sehr nass '+
			  '<span class="dot" style="background-color:#82d732;"></span>=normal '+
			  '<span class="dot" style="background-color:#fac83c;"></span>=trocken '+
			  '<span class="dot" style="background-color:#c8642d;"></span>=sehr trocken '+
			  ' - © <a href="https://services.arcgisonline.com/ArcGIS/' +
                  'rest/services/World_Imagery/MapServer">ArcGIS</a>',
              url: 'https://server.arcgisonline.com/ArcGIS/rest/services/' +
                  'World_Imagery/MapServer/tile/{z}/{y}/{x}'
            })
          })
		]	
	})	
  ],
  overlays: [overlay],
  target: 'map',
  view: new View({
    center: fromLonLat([13.47896,50.9846]),//[10.57896,51.3846],
    zoom: 8.3
}),
  controls: defaultControls({attribution: false}).extend([attribution,new KlimaControl(),new WaldControl(),new BucheControl(),new FichteControl(),new EicheControl(),new KieferControl(),new GrasControl()]),
  /*renderer: 'webgl'*/
});


map.addLayer(new LayerGroup({
	title: 'Wald',
	layers: [vectorLayerL ,vectorLayerWuchsbezirke,vectorLayerPlots_bwlf],//vectorLayerL ,vectorLayerPlots_100,vectorLayerPlots_80,vectorLayerPlots]//,vectorLayerPlots_80,vectorLayerPlots_100,vectorLayerPlots_grass_100,vectorLayerPlots_grass_80,vectorLayerPlots_grass_40,vectorLayerPlots_pine_100,vectorLayerPlots_pine_80,vectorLayerPlots_pine_40,vectorLayerPlots_oak_100,vectorLayerPlots_oak_80,vectorLayerPlots_oak_40,vectorLayerPlots_beech_100,vectorLayerPlots_beech_80,vectorLayerPlots_beech_40,vectorLayerDownload]
}))

var layerSwitcher = new LayerSwitcher({
    tipLabel: 'Legende', // Optional label for button
	 groupSelectStyle: 'none'
});



map.addControl(layerSwitcher);

//------------------------------------------------------------------------

var select = null; // ref to currently selected interaction

// select interaction working on "singleclick"
var selectSingleClick = new Select();

// select interaction working on "click"
var selectClick = new Select({
  condition: click,
  layers: [vectorLayerPlots,vectorLayerPlots_80,vectorLayerPlots_100,vectorLayerPlots_grass_100,vectorLayerPlots_grass_80,vectorLayerPlots_grass_40,vectorLayerPlots_pine_100,vectorLayerPlots_pine_80,vectorLayerPlots_pine_40,vectorLayerPlots_oak_100,vectorLayerPlots_oak_80,vectorLayerPlots_oak_40,vectorLayerPlots_beech_100,vectorLayerPlots_beech_80,vectorLayerPlots_beech_40,vectorLayerDownload,vectorLayerPlots_bwlf]
});

// select interaction working on "pointermove"
var selectPointerMove = new Select({
  condition: pointerMove, //LISTE VON SELECTABLKE LAYERS
  layers: [vectorLayerPlots,vectorLayerPlots_80,vectorLayerPlots_100,vectorLayerPlots_grass_100,vectorLayerPlots_grass_80,vectorLayerPlots_grass_40,vectorLayerPlots_pine_100,vectorLayerPlots_pine_80,vectorLayerPlots_pine_40,vectorLayerPlots_oak_100,vectorLayerPlots_oak_80,vectorLayerPlots_oak_40,vectorLayerPlots_beech_100,vectorLayerPlots_beech_80,vectorLayerPlots_beech_40,vectorLayerDownload,vectorLayerPlots_bwlf]
});

var selectAltClick = new Select({
  condition: function (mapBrowserEvent) {
    return click(mapBrowserEvent) && altKeyOnly(mapBrowserEvent);
  },
});

var selected = null;
var clicked = null;

select = selectPointerMove;
map.addInteraction(select);
    select.on('select', function (e) {
		
		glStyle.variables.selectedFeatureId = e.selected.length ? e.selected[0].get('id') : '';
		glStyleWB.variables.selectedFeatureId = e.selected.length ? e.selected[0].get('id') : '';
		
		if(clicked!== null)
			clicked.setStyle(clickedStyle); 
		
		if (selected){ 
			glStyle.variables.clickedFeatureId = e.selected.length ? selected.get('id') : selected.get('id');
			glStyleWB.variables.clickedFeatureId = e.selected.length ? selected.get('id') : selected.get('id');
		}
		//alert(e.selected.length ? e.selected[0].get('id') : '')
		//e.selected[0].getTargetElement().style.cursor = 'pointer';
		/*
		
		map.forEachFeatureAtPixel(e.pixel, function (f) {
			selected = f;
			//f.setStyle(highlightStyle);
			return true;
		});

		if (selected) {
			this.getTargetElement().style.cursor = 'pointer';
			//  document.getElementById("statuss").innerHTML = '&nbsp;Hovering: '+ selected.get('NAMEID');
		} else {
			this.getTargetElement().style.cursor = '';
			//  document.getElementById("statuss").innerHTML = '';
		}*/
    });
//----------------new sleect




/*
map.on('pointermove', function (e) {
  if (selected !== null) {
    selected.setStyle(undefined);
	selected = null;
  }
  if(clicked !== null){
	  clicked.setStyle(clickedStyle);
  }

  map.forEachFeatureAtPixel(e.pixel, function (f) {
    selected = f;
    f.setStyle(highlightStyle);
    return true;
  });

  if (selected) {
	  this.getTargetElement().style.cursor = 'pointer';
	//  document.getElementById("statuss").innerHTML = '&nbsp;Hovering: '+ selected.get('NAMEID');
  } else {
	  this.getTargetElement().style.cursor = '';
	//  document.getElementById("statuss").innerHTML = '';
  }
});
*/
var nodelegend=document.querySelector('[title="Legende"]');  
	
/**
       * Add a click handler to the map to load the data and render the charts.
*/
map.on('click', function(evt) {
	
	var layername='';
		map.forEachFeatureAtPixel(evt.pixel, function (f) {
			if (typeof f.get('id') !== 'undefined'){
				selected = f;
				return true;
			}else{
				return false;
			}	
		});
	    var pixel = map.getEventPixel(evt.originalEvent);
		var hit = map.hasFeatureAtPixel(pixel/*,{
				layerFilter: function (layer) {
				return (layer.get('uuid') !== 'saxony');}
				}*/
		);
		
	if(hit){		
		document.getElementById('loadingGif').style.visibility = 'hidden';
		var feature = map.forEachFeatureAtPixel(evt.pixel,
          function(feature, layer) {
			 if (clicked !== null) {
					clicked.setStyle(undefined);
					clicked = null;
					 document.getElementById("statuss").innerHTML = '';
					 document.getElementById("station").innerHTML = '';
					 document.getElementById("levelII").innerHTML = '';
					 document.getElementById("SAbk").innerHTML = '';
					 layername='';
			} 
			  layername=layer.get('uuid');
			  if(layername=='saxony'||layername=='wuchsbezirke' ){
				  feature.setStyle(undefined);
				  hit=false;
				  feature=null;
			  }else if(layername=='plots_bwlf'){
				  feature.setStyle(undefined);
				  hit=false;
				  feature=null;
				  document.getElementById('popup').style.visibility = 'visible';
				  const coordinate = evt.coordinate;		/**pop-up winodw after click**/
				  /** var vegi_de='Fichte';
			var vegi_en='Spruce_Forest';
			if(layername.includes("pine")){
				vegi_de='Kiefer';
				vegi_en='Pine_Forest';
			}
			if(layername.includes("beech")){
				vegi_de='Buche';
				vegi_en='Beech_Forest';
			}
			if(layername.includes("oak")){
				vegi_de='Eiche';
				vegi_en='Oak_Forest';
			}
			if(layername.includes("grass")){
				vegi_de='Gras';
				vegi_en='Grass_Land';
			}**/
					var eiCol="background-color: #5b9ad5;"
					var buCol="background-color: #5b9ad5;"
					var fiCol="background-color: #5b9ad5;"
					var kiCol="background-color: #5b9ad5;"
					var grCol="background-color: #5b9ad5;"
					
					if(selected.get("HB")=="EI"){
						 eiCol="background-color: #51c5d5;"
					}	
					if(selected.get("HB")=="BU"){
						buCol="background-color: #51c5d5;"
					}	
					if(selected.get("HB")=="FI"){
						fiCol="background-color: #51c5d5;"
					}	
					if(selected.get("HB")=="KI"){
						kiCol="background-color: #51c5d5;"
					}	
			
					content.innerHTML = '<div>Lokalbodenform: <b>'+selected.get("LF")+'</b></div><br>Zielbaumarten (dominierende hell):<br><div style="height:100px;width:150px;"><button id="b123" class="BaumButton" type="button"  style="position:absolute;top: 80px;left: 30px;width: 50px;height: 20px;'+buCol+'border: none;">Buche</button><button id="b124" class="BaumButton" type="button"  style="position:absolute;top: 80px;left: 90px;width: 50px;height: 20px;'+fiCol+'border: none;">Fichte</button><button id="b125" class="BaumButton" type="button"  style="position:absolute;top: 110px;left: 30px;width: 50px;height: 20px;'+kiCol+'border: none;">Kiefer</button><button id="b126" class="BaumButton" type="button"  style="position:absolute;top: 110px;left: 90px;width: 50px;height: 20px;'+eiCol+'border: none;">Eiche</button><button id="b127" class="BaumButton" type="button"  style="position:absolute;top: 140px;left: 30px;width: 50px;height: 20px;'+grCol+'border: none;">Gras</button></div>';
					var bwiID=String(selected.get('HB'));
					document.getElementById('b123').setAttribute('onClick', 'document.getElementById("statuss").innerHTML = "Ausgewählter Standort:&nbsp;'+ selected.get('BWI_ID') + ' &nbsp; Vegetation: Buche &nbsp; REW: 40cm Bodentiefe <br> Letzte Aktualisierung: '+today+'";loadREWdataandShowGraphs(\"Beech_Forest\",\"'+selected.get("BWI_ID")+'\");');
					document.getElementById('b124').setAttribute('onClick', 'document.getElementById("statuss").innerHTML = "Ausgewählter Standort:&nbsp;'+"47440_4"+' &nbsp; Vegetation: Fichte &nbsp; REW: 40cm Bodentiefe <br> Letzte Aktualisierung: '+today+'";loadREWdataandShowGraphs(\"Spruce_Forest\",\"'+selected.get("BWI_ID")+'\");');
					document.getElementById('b125').setAttribute('onClick', 'document.getElementById("statuss").innerHTML = "Ausgewählter Standort:&nbsp;'+"47440_4"+' &nbsp; Vegetation: Kiefer &nbsp; REW: 40cm Bodentiefe <br> Letzte Aktualisierung: '+today+'";loadREWdataandShowGraphs(\"Pine_Forest\",\"'+selected.get("BWI_ID")+'\");');
					document.getElementById('b126').setAttribute('onClick', 'document.getElementById("statuss").innerHTML = "Ausgewählter Standort:&nbsp;'+"47440_4"+' &nbsp; Vegetation: Eiche &nbsp; REW: 40cm Bodentiefe <br> Letzte Aktualisierung: '+today+'";loadREWdataandShowGraphs(\"Oak_Forest\",\"'+selected.get("BWI_ID")+'\");');
					document.getElementById('b127').setAttribute('onClick', 'document.getElementById("statuss").innerHTML = "Ausgewählter Standort:&nbsp;'+"47440_4"+' &nbsp; Vegetation: Gras &nbsp; REW: 40cm Bodentiefe <br> Letzte Aktualisierung: '+today+'";loadREWdataandShowGraphs(\"Grass_Land\",\"'+selected.get("BWI_ID")+'\");');
					
					/*"<div style='height:100px;width:100px;'><button type='button' onclick='document.getElementById(\"statuss\").innerHTML = \" Letzte Aktualisierung: \"+"+today+";loadREWdataandShowGraphs1(\"Beech_Forest\",\"47440_4\");' style='position:absolute;top: 0px;left: 0px;width: 50px;height: 20px;'>Buche</button></div>";*/
					overlay.setPosition(coordinate);
			  }else{
				clicked= feature;
				feature.setStyle(clickedStyle); 
			  }
            return feature;
        });

		if (feature) { 
		// alert(feature);
		 
			var vegi_de='Fichte';
			var vegi_en='Spruce_Forest';
			if(layername.includes("pine")){
				vegi_de='Kiefer';
				vegi_en='Pine_Forest';
			}
			if(layername.includes("beech")){
				vegi_de='Buche';
				vegi_en='Beech_Forest';
			}
			if(layername.includes("oak")){
				vegi_de='Eiche';
				vegi_en='Oak_Forest';
			}
			if(layername.includes("grass")){
				vegi_de='Gras';
				vegi_en='Grass_Land';
			}
				
			if(layername.includes("Download")){
				document.getElementById("SoilMoisturePanel").style.visibility = "hidden"; 
				document.getElementById("DownloadPanel").style.visibility = "visible"; 
				document.getElementById("SoilMoistureDummyPanel").style.visibility = "hidden"; 
				document.getElementById("SoilMoistureImpressumPanel").style.visibility = "hidden"; 
				document.getElementById('SoilMoistureAboutPanel').style.visibility = 'hidden';
				document.getElementById('statuss').style.visibility = 'visible';
				document.getElementById('statuss').style.visibility = 'visible';
				document.getElementById('statuss').innerHTML = 'Ausgewählter Standort:&nbsp;'+ selected.get('id');
				//	document.getElementById('Bodenprofilpic').style.visibility = 'hidden';
			}else{
				document.getElementById('statuss').innerHTML = 'Ausgewählter Standort:&nbsp;'+ selected.get('id') + ' &nbsp; Vegetation: '+vegi_de+' &nbsp; REW: 40cm Bodentiefe <br> Letzte Aktualisierung: '+today;
				//document.getElementById('Bodenprofilpic').src = 'https://rekisviewer.hydro.tu-dresden.de/viewer/BoFeAm/Soil_profile_plots/' + selected.get('id') + '.png';
				//document.getElementById('Bodenprofilpic').style.visibility = 'visible';  SOEH_LNG
				document.getElementById('popup').style.visibility = 'visible';
				const coordinate = evt.coordinate;		/**pop-up winodw after click**/
				
				var plot_index = objSoilDepth.findIndex(function(item, i){
					return item.id === selected.get('id')
				});
				content.innerHTML = '<div style="width:380px;">Bodenprofilname: '+objSoilDepth[plot_index].SOEH_LNG+'<img  src="' + 	'https://rekisviewer.hydro.tu-dresden.de/viewer/BoFeAm/Soil_profile_plots/' + selected.get("id") + '.png" style="width:100%"> </div>';
				overlay.setPosition(coordinate);
			}
			document.getElementById('stationName').innerHTML = selected.get('id');
			document.getElementById('station').innerHTML = selected.get('ElemID');
			document.getElementById('SAbk').innerHTML = selected.get('Abk');
			document.getElementById('levelII').innerHTML = selected.get('LevelII');
			//document.getElementById('heatmapi').style.visibility="visible";
			
			ApexCharts.exec('quantiles','updateSeries',[{data:[]}],true);
			ApexCharts.exec('depth_rew','updateSeries',[{data:[]}],true);
			ApexCharts.exec('downloaddata','updateSeries',[{data:[]}],true);
			ApexCharts.exec('downloaddata2','updateSeries',[{data:[]}],true);
			
			

			function storeDownloadData(posix, max, array) {
				array.push({ x:posix,y:(Math.round(max* 100) / 100)});
			}
			function storeDownloadDataBF(posix, max, array) {
				array.push({ x:posix,y:(Math.round(max* 100) / 100)});
			}

			function readTextFile(file, callback) {
				var rawFile = new XMLHttpRequest();
				rawFile.overrideMimeType("application/json");
				rawFile.open("GET", file, true);
				rawFile.onreadystatechange = function() {
				if (rawFile.readyState === 4 && rawFile.status == "200") {
					callback(rawFile.responseText);
					}
				}
				rawFile.send(null);
			}

			if(dodownloadstuff && hit){
				const downloaddaten_median=[];
				const downloaddaten_max=[];
				const downloaddaten_min=[];
				const downloaddaten_2median=[];
				
				var dd = new Date();
				dd.setDate(dd.getDate()-7);
			
				var monati=(dd.getMonth()+1);
				if(monati<10)
					{monati='0'+(dd.getMonth()+1)}
	
				var tagi=(dd.getDate());
				if(tagi<10)
					{tagi='0'+(dd.getDate())}
	
				document.getElementById("elementline").innerHTML="TT";
				document.getElementById("elementunit").innerHTML="Temperatur [°C]";
				document.getElementById("timeserieslength").innerHTML="1";
				document.getElementById("numofinterval").innerHTML="R7";
				document.getElementById("summean").innerHTML="mean";
				document.getElementById("Aggregierung1").options.selectedIndex =1;
				document.getElementById("buttonID").innerHTML="ButAj1";
				
				document.getElementById("aggre").innerHTML="P1D";
				const buttons11 = document.querySelectorAll('.buttonA');
					buttons11.forEach(butt => {
					butt.style.backgroundColor = '#5b9ad5';
				});
				
				const buttons22 = document.querySelectorAll('.buttonT');
					buttons22.forEach(butts => {
					butts.style.backgroundColor = '#5b9ad5';
				});
				document.getElementById('Export1').disabled = false;
				document.getElementById('ButAj1').style.backgroundColor = '#4479ab';
	
	//alert('https://api.sh-rekis.hydro.tu-dresden.de/v0/networks/sachsenforst-meteo/devices/'+selected.get('ElemID')+'/sensors/TT/measurements?interval=R7/'+(dd.getFullYear())+'-'+monati+'-'+tagi+'T00:00:00Z/P1D&agg=mean');
	
				readTextFile('https://api.sh-rekis.hydro.tu-dresden.de/v0/networks/sachsenforst-meteo/devices/'+selected.get('ElemID')+'/sensors/TT/measurements?interval=R7/'+(dd.getFullYear())+'-'+monati+'-'+tagi+'T00:00:00Z/P1D&agg=mean', function(textt){

					var obj = JSON.parse(textt);

			
					for (var i in obj) { 
						if(obj[i].v!=null){
							storeDownloadDataBF(new Date(obj[i].begin).valueOf(),obj[i].v, downloaddaten_median);
							storeDownloadDataBF(new Date(obj[i].begin).valueOf(),obj[i].lo, downloaddaten_min);
							storeDownloadDataBF(new Date(obj[i].begin).valueOf(),obj[i].hi, downloaddaten_max);
						}
					}

						ApexCharts.exec('downloaddata','updateOptions',{
							chart: {
								//height: 350,
								type: 'line',
							},
								stroke: {
								width: 2,
							},
								yaxis: {
									//type: 'datetime',
									title: { text: 'Temperatur [°C]'},
									//min: new Date(startdate).getTime(),
									//tickAmount: 12
							},
								title: {
									text: 'Temperatur [°C]',
									//align: 'left',
								},
							noData:{
									text: 'Möglicherweise ist der gewählte Zeitraum zu kurz.',
								},
							},false,true);
							if(downloaddaten_median!=0)
								ApexCharts.exec('downloaddata','updateSeries',[
									{ name: 'Tagesmittel',
										type: 'line',
										data: downloaddaten_median,
								},{ name: 'Minimum',
										type: 'line',
										data: downloaddaten_min,
								},{ name: 'Maximum',
										type: 'line',
										data: downloaddaten_max,
								}]);
				
			//}		
				});
	
			document.getElementById("elementline2").innerHTML="RR";
			document.getElementById("elementunit2").innerHTML="Niederschlag [mm]";
			document.getElementById("timeserieslength2").innerHTML="1";
			document.getElementById("numofinterval2").innerHTML="R7";
			document.getElementById("summean2").innerHTML="sum";
			document.getElementById("Aggregierung2").options.selectedIndex =0;
			document.getElementById("aggre2").innerHTML="P1D";
			document.getElementById("buttonID2").innerHTML="ButAj2";
			
			document.getElementById('Export2').disabled = true;
			const buttons1 = document.querySelectorAll('.buttonA2');
					buttons1.forEach(butt => {
					butt.style.backgroundColor = '#5b9ad5';
				});
				//document.getElementById(button).style.backgroundColor = '#4479ab';
			const buttonss1 = document.querySelectorAll('.buttonT2');
					buttonss1.forEach(butts => {
					butts.style.backgroundColor = '#5b9ad5';
				});
			document.getElementById('ButAj2').style.backgroundColor = '#4479ab';
	
			//alert('https://api.sh-rekis.hydro.tu-dresden.de/v0/networks/sachsenforst-meteo/devices/'+selected.get('ElemID')+'/sensors/RR/measurements?interval=R7/'+(dd.getFullYear())+'-'+monati+'-'+tagi+'T00:00:00Z/P1D&agg=sum');
				readTextFile('https://api.sh-rekis.hydro.tu-dresden.de/v0/networks/sachsenforst-meteo/devices/'+selected.get('ElemID')+'/sensors/RR/measurements?interval=R7/'+(dd.getFullYear())+'-'+monati+'-'+tagi+'T00:00:00Z/P1D&agg=sum', function(textt){
					var obj2 = JSON.parse(textt);
			
					for (var i in obj2) { 
						if(obj2[i].v!=null){
							storeDownloadDataBF(new Date(obj2[i].begin).valueOf(),obj2[i].v, downloaddaten_2median);
						}
					}
		
					ApexCharts.exec('downloaddata2','updateOptions',{
						chart: {
							//height: 350,
							type: 'line',
						},
							stroke: {
							width: 2,
						},
							yaxis: {
							//type: 'datetime',
							title: { text: 'Niederschlag [mm]'},
							//min: new Date(startdate).getTime(),
							//tickAmount: 12
						},
							title: {
								text: 'Niederschlag [mm]',
								//align: 'left',
							},
							noData:{
									text: 'Möglicherweise ist der gewählte Zeitraum zu kurz.',
								},
					},false,true);
					if(downloaddaten_2median!=0)
						ApexCharts.exec('downloaddata2','updateSeries',[
						{ 	name: 'gemessen',
							type: 'column',
							data: downloaddaten_2median,
						}]);
				
			});
		};/*end if dodownloadstuff & hit*/

			if(dorewstuff && hit){
				loadREWdataandShowGraphs(vegi_en,selected.get('id')) //vegi_en),selected.get('id')
			}/*end if dorewstuff & hit*/
		}/*end feature*/
	}/*end if(hit)*/
		
});/* end onclik for map*/

});});});});});});});});});});});});});

});});});});

window.loadREWdataandShowGraphs=function(vegi_name,jsonID) //vegi_en),selected.get('id')
{
	//usage:
	//var getJSON=require('get-json');
	//var json=$.getJSON('/Spruce/rew_Quantile/'+selected.get('id')+'.json');
	document.getElementById('SoilMoisturePanel').style.visibility = 'visible';
	document.getElementById('DownloadPanel').style.visibility = 'hidden';	
	document.getElementById('SoilMoistureDummyPanel').style.visibility = 'hidden';
	document.getElementById('SoilMoistureImpressumPanel').style.visibility = 'hidden';
	document.getElementById('statuss').style.visibility = 'visible';
	document.getElementById('statuss').style.visibility = 'visible';
	document.getElementById('SoilMoistureAboutPanel').style.visibility = 'hidden';
	document.getElementById('expBtn').focus();
	//document.getElementById('Bodenprofilpic').style.visibility = 'visible';
	

	readTextFile('https://rekisviewer.hydro.tu-dresden.de/viewer/BoFeAm/'+vegi_name+'/rew_Quantile/'+jsonID+'.json', function(text){
		//alert(text);https://rekisviewer.hydro.tu-dresden.de/viewer/BoFeAm/Spruce/rew_Quantile/
	
		var obj = JSON.parse(text);
		const quantildaten_median=[];
	
		for (var i in obj) {   
			storeData(obj[i].DOY,obj[i].median, quantildaten_median);
		}
		var dati =JSON.parse(JSON.stringify(quantildaten_median));
	
		const mindaten=[];
		for (var i in obj) {   
			storeData(obj[i].DOY,obj[i].min, mindaten);
		}
		var dati_min=JSON.parse(JSON.stringify(mindaten));

		const daten25=[];
		for (var i in obj) {   
			storeData(obj[i].DOY,obj[i].Q25, daten25);
		}
		var dati_25=JSON.parse(JSON.stringify(daten25));

		const daten75=[];
		for (var i in obj) {   
			storeData(obj[i].DOY,obj[i].Q75, daten75);
		}
		var dati_75=JSON.parse(JSON.stringify(daten75));

		const daten10=[];
		for (var i in obj) {   
			storeData(obj[i].DOY,obj[i].Q10, daten10);
		}
		var dati_10=JSON.parse(JSON.stringify(daten10));	

		const daten90=[];
		for (var i in obj) {   
			storeData(obj[i].DOY,obj[i].Q90, daten90);
		}
		var dati_90=JSON.parse(JSON.stringify(daten90));

		const maxdaten=[];
		for (var i in obj) {   
			storeData(obj[i].DOY,obj[i].max, maxdaten);
		}
		var dati_max=JSON.parse(JSON.stringify(maxdaten));

		const currentdaten=[];
		for (var i in obj) {   
			storeData(obj[i].DOY,obj[i].current, currentdaten);
		}
		var dati_current=JSON.parse(JSON.stringify(currentdaten));	  
		ApexCharts.exec('quantiles','updateSeries',[
			{
            name: 'Sehr feucht (90. Quantil bis Maximum)',
            data: dati_max,
			type: 'area',
			color:'#81D4FA',
          },{
            name: 'Feucht (75. bis 90. Quantil)',
            data: dati_90,
			type: 'area',
			color:'#03a9f4',
          },{
            name: 'Median (25. bis 75. Quantil)',
            data: dati_75,
			type: 'area',
			color: '#008FFB',
          },/*
		  {
            name: 'Median',
            data: quantildaten_median,
			type: 'area',
			color: '#008FFB',
          },*/{
            name: 'Trocken (10. bis 25. Quantil)',
            data: dati_25,
			type: 'area',
			color:'#03a9f4',
          },{
            name: 'Sehr trocken (10. Quantil bis Minimum)',
            data: dati_10,
			type: 'area',
			color:'#81D4FA',
          },{
            name: ' ',
            data: dati_min,
			type: 'area',
			color:'#FFFFFF',
          },
		   
		  {
           name: "Aktueller REW",
           type: "line",
           data: dati_current,
		   color: '#D7263D',
	
         },
          
		],true);
   
	});

	function storeDataHeat(Dat,max, array) {
		array.push({ x:Dat,y:max});
	}

	readTextFile('https://rekisviewer.hydro.tu-dresden.de/viewer/BoFeAm/'+vegi_name+'/rew_layer/'+jsonID+'.json', function(text){
		//alert(text);
	
		var objheat = JSON.parse(text);

		const depth_rew_5=[];
		const startdate=objheat[0].daytime;//"1 1 2020";


		for (var i in objheat) {   
			storeDataHeat((objheat[i].datetimeposix*1000),objheat[i].d5, depth_rew_5);
		}
		const depth_rew_10=[];
		for (var i in objheat) {   
			storeDataHeat((objheat[i].datetimeposix*1000),objheat[i].d10, depth_rew_10);
		}
		const depth_rew_20=[];
		for (var i in objheat) {   
			storeDataHeat((objheat[i].datetimeposix*1000),objheat[i].d20, depth_rew_20);
		}
		const depth_rew_30=[];
		for (var i in objheat) {   
			storeDataHeat((objheat[i].datetimeposix*1000),objheat[i].d30, depth_rew_30);
		}
		const depth_rew_40=[];
		for (var i in objheat) {   
			storeDataHeat((objheat[i].datetimeposix*1000),objheat[i].d40, depth_rew_40);
		}
		const depth_rew_50=[];
		for (var i in objheat) {   
			storeDataHeat((objheat[i].datetimeposix*1000),objheat[i].d50, depth_rew_50);
		}
		const depth_rew_60=[];
		for (var i in objheat) {   
			storeDataHeat((objheat[i].datetimeposix*1000),objheat[i].d60, depth_rew_60);
		}
		const depth_rew_70=[];
		for (var i in objheat) {   
			storeDataHeat((objheat[i].datetimeposix*1000),objheat[i].d70, depth_rew_70);
		}
		const depth_rew_80=[];
		for (var i in objheat) {   
			storeDataHeat((objheat[i].datetimeposix*1000),objheat[i].d80, depth_rew_80);
		}
		const depth_rew_90=[];
		for (var i in objheat) {   
			storeDataHeat((objheat[i].datetimeposix*1000),objheat[i].d90, depth_rew_90);
		}
		const depth_rew_100=[];
		for (var i in objheat) {   
			storeDataHeat((objheat[i].datetimeposix*1000),objheat[i].d100, depth_rew_100);
		}
		/*const depth_rew_110=[];
		for (var i in objheat) {   
			storeDataHeat(objheat[i].datetimeposix,objheat[i].d110, depth_rew_110);
		}
		const depth_rew_120=[];
		for (var i in objheat) {   
			storeDataHeat(objheat[i].datetimeposix,objheat[i].d120, depth_rew_120);
		}
		const depth_rew_130=[];
		for (var i in objheat) {   
			storeDataHeat(objheat[i].datetimeposix,objheat[i].d130, depth_rew_130);
		}
		const depth_rew_140=[];
		for (var i in objheat) {   
			storeDataHeat(objheat[i].datetimeposix,objheat[i].d140, depth_rew_140);
		}
		const depth_rew_150=[];
		for (var i in objheat) {   
			storeDataHeat(objheat[i].datetimeposix,objheat[i].d150, depth_rew_150);
		}*/



		ApexCharts.exec('depth_rew','updateSeries',[
			/*{
				  name: '150',
				  data: depth_rew_150,
				},
			{
				  name: '140',
				  data: depth_rew_140,
				},
			{
				  name: '130',
				  data: depth_rew_130,
				},	
			{
					name: '120',
				data: depth_rew_120,
			},
			{
				name: '110',
				data: depth_rew_110,
			},*/
			{
				name: '100',
				data: depth_rew_100,
			},
			{
				name: '90',
				data: depth_rew_90,
			},
			{
				name: '80',
				data: depth_rew_80,
			},
			{
				name: '70',
				data: depth_rew_70,
			},
			{
				name: '60',
				data: depth_rew_60,
			},
			{
				name: '50',
				data: depth_rew_50,
			},		
			{ 
				name: '40',
				data: depth_rew_40,
			},
			{
				name: '30',
				data: depth_rew_30,
			},
			{	
				name: '20',
				data: depth_rew_20,
			},
			{
				name: '10',
				data: depth_rew_10,
			},
			{
				name: '5',
				data: depth_rew_5,
			}	
		],false);	

		var plot_index = objSoilDepth.findIndex(function(item, i){
			return item.id === jsonID
		});
		var dep_id=0;
		if(objSoilDepth[plot_index].soil_depth<1.0) 
			dep_id=2-objSoilDepth[plot_index].soil_depth*2

	

		ApexCharts.exec('depth_rew','updateOptions',{
				xaxis: {
					type: 'datetime',
					//title: { text: "Datum"},
					//min: new Date(startdate).getTime(),
					tickAmount: 12
				},
				annotations: {
					yaxis: [
					{
						y: dep_id,
						borderColor: '#fac83c',
						strokeDashArray: 0,
						label: {
							show: true,
							text: objSoilDepth[plot_index].soil_depth+'m maximale Bodenmächtigkeit',
							style: {
								color: "#000",
								background: '#fac83c'
							}
						}
					},]
				},
			},false,true);

	});	 
}


